export default __webpack_public_path__ + "static/media/asset4.289b6646.png";